module.exports = __webpack_public_path__ + "static/media/segurosUnimed.374b518d.png";